/* Shopify Predictive Search JSON API: prices are decimal amounts, not cents.
   https://shopify.dev/docs/api/ajax/reference/predictive-search */
(function () {
  var cache = new Map();
  document.querySelectorAll('[data-vx-predictive]').forEach(function (form) {
    var input = form.querySelector('input[type="search"]');
    if (!input || form.dataset.predictiveReady) return;
    form.dataset.predictiveReady = 'true';
    var popup = document.createElement('div');
    popup.className = 'vx-predictive-results';
    popup.id = input.id + '-results';
    popup.setAttribute('role', 'listbox');
    popup.setAttribute('aria-label', 'Suggested products');
    popup.hidden = true;
    var status = document.createElement('span');
    status.className = 'vx-sr-only';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    form.appendChild(popup);
    form.appendChild(status);
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', popup.id);
    input.setAttribute('aria-expanded', 'false');
    var timer, controller, version = 0, active = -1;

    function resetActive() {
      active = -1;
      input.removeAttribute('aria-activedescendant');
      popup.querySelectorAll('[role="option"]').forEach(function (link) { link.setAttribute('aria-selected', 'false'); });
    }
    function close() {
      version++;
      clearTimeout(timer);
      if (controller) controller.abort();
      popup.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-busy');
      status.textContent = '';
      resetActive();
    }
    function searchURL(query) {
      var url = new URL(form.action, window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      return url.href;
    }
    function price(product) {
      var amount = Number(product.price);
      if (!Number.isFinite(amount)) return '';
      var currency = form.dataset.currency || 'USD';
      var formatted;
      try { formatted = new Intl.NumberFormat(form.dataset.locale || 'en', {style: 'currency', currency: currency}).format(amount); }
      catch (error) { formatted = currency + ' ' + amount.toFixed(2); }
      return (Number(product.price_max) > Number(product.price_min) ? 'From ' : '') + formatted + (product.available === false ? ' · Sold out' : '');
    }
    function safeURL(value, image) {
      try {
        var url = new URL(value, window.location.origin);
        if (!/^https?:$/.test(url.protocol)) return null;
        if (!image && url.origin !== window.location.origin) return null;
        return url.href;
      } catch (error) { return null; }
    }
    function render(products, query, error) {
      popup.replaceChildren();
      resetActive();
      if (!products.length) {
        var message = document.createElement('p');
        message.className = 'vx-predictive-empty';
        message.setAttribute('role', 'presentation');
        message.textContent = error ? 'Preview unavailable. Use search to see results.' : 'No matching products found.';
        popup.appendChild(message);
      }
      products.forEach(function (product, index) {
        var url = safeURL(product.url, false);
        if (!url) return;
        var link = document.createElement('a');
        link.className = 'vx-predictive-link';
        link.href = url;
        link.id = popup.id + '-' + index;
        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', 'false');
        var imageURL = safeURL(product.featured_image && product.featured_image.url || product.image || '', true);
        if (imageURL && (product.image || product.featured_image && product.featured_image.url)) {
          var image = document.createElement('img');
          image.className = 'vx-predictive-image';
          image.src = imageURL;
          image.alt = '';
          image.width = 48;
          image.height = 48;
          image.loading = 'lazy';
          link.appendChild(image);
        }
        var copy = document.createElement('span');
        copy.className = 'vx-predictive-copy';
        var name = document.createElement('span');
        name.className = 'vx-predictive-name';
        name.textContent = product.title;
        var cost = document.createElement('span');
        cost.className = 'vx-predictive-price';
        cost.textContent = price(product);
        copy.appendChild(name);
        copy.appendChild(cost);
        link.appendChild(copy);
        popup.appendChild(link);
      });
      var all = document.createElement('a');
      all.className = 'vx-predictive-link vx-predictive-all';
      all.href = searchURL(query);
      all.id = popup.id + '-all';
      all.textContent = 'View all results for “' + query + '”';
      all.setAttribute('role', 'option');
      all.setAttribute('aria-selected', 'false');
      popup.appendChild(all);
      popup.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      input.removeAttribute('aria-busy');
      status.textContent = error ? 'Product preview unavailable.' : products.length + ' product suggestions. Use the arrow keys to browse.';
    }
    function request() {
      clearTimeout(timer);
      if (controller) controller.abort();
      var query = input.value.trim();
      if (query.length < 2) { close(); return; }
      var current = ++version;
      popup.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      resetActive();
      timer = setTimeout(function () {
        var endpoint = new URL(form.dataset.predictiveUrl, window.location.origin);
        endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.json';
        endpoint.searchParams.set('q', query);
        endpoint.searchParams.set('resources[type]', 'product');
        endpoint.searchParams.set('resources[limit]', '6');
        endpoint.searchParams.set('resources[options][unavailable_products]', 'last');
        var key = endpoint.href;
        if (cache.has(key)) { render(cache.get(key), query); return; }
        controller = new AbortController();
        input.setAttribute('aria-busy', 'true');
        status.textContent = 'Searching products…';
        fetch(key, {signal: controller.signal, headers: {'Accept': 'application/json'}})
          .then(function (response) { if (!response.ok) throw new Error('Search unavailable'); return response.json(); })
          .then(function (data) {
            if (current !== version) return;
            var products = data.resources && data.resources.results && data.resources.results.products;
            if (!Array.isArray(products)) throw new Error('Search unavailable');
            products = products.slice(0, 6);
            if (cache.size >= 20) cache.delete(cache.keys().next().value);
            cache.set(key, products);
            render(products, query);
          })
          .catch(function (error) { if (error.name !== 'AbortError' && current === version) render([], query, true); });
      }, 220);
    }
    input.addEventListener('input', function (event) { if (!event.isComposing) request(); });
    input.addEventListener('compositionend', request);
    input.addEventListener('focus', function () { if (input.value.trim().length >= 2 && !input.classList.contains('hint')) request(); });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { close(); return; }
      if (popup.hidden || event.isComposing) return;
      var options = Array.from(popup.querySelectorAll('[role="option"]'));
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        active = active < 0 ? (event.key === 'ArrowDown' ? 0 : options.length - 1) : (active + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
        options.forEach(function (option, index) { option.setAttribute('aria-selected', String(index === active)); });
        input.setAttribute('aria-activedescendant', options[active].id);
        options[active].scrollIntoView({block: 'nearest'});
      } else if (event.key === 'Enter' && active >= 0) {
        event.preventDefault();
        window.location.assign(options[active].href);
      }
    });
    form.addEventListener('focusout', function () { setTimeout(function () { if (!form.contains(document.activeElement)) close(); }, 0); });
    form.addEventListener('submit', close);
    document.addEventListener('pointerdown', function (event) { if (!form.contains(event.target)) close(); });
  });
})();
